import {DurationOptions} from "./constants"
export function getDurationFromTimeRange(timeRange){
    return  Object.keys(DurationOptions).find(option=>
        DurationOptions[option].timeRange === timeRange
    )
}

export function getTimeRangeFromDuration(duration){
    return DurationOptions[duration].timeRange
}